let locations = [
  {
    state : "Texas",
    icon: "../../../assets/state_svg/TX.svg",
    cities : [
      {
        city: "Dallas",
        office_address: "17430 Campbell Rd #103, Dallas, TX 75252",
        phone_number: "(469) 329-0962"
      },
      {
        city: "Houston",
        office_address: "7070 Knights Ct, Suite 402 Missouri City, TX 77459",
        phone_number: "(832) 391-5000"
      },
      {
        city: "Austin",
        office_address: "We are almost there!",
        phone_number: "Coming Soon"
      },
    ]
  },
  {
    state : "Georgia",
    icon: "../../../assets/state_svg/GA.svg",
    cities : [
      {
        city: "Atlanta",
        office_address: "4100 Nine McFarland Drive Suite D, Alpharetta, GA 30004",
        phone_number: "4696618966"
      }
    ]
  },
  {
    state : "Florida",
    icon: "../../../assets/state_svg/FL.svg",
    cities : [
      {
        city: "Tampa",
        office_address: "We are almost there!",
        phone_number: "Coming Soon!"
      }
    ]
  },
]

export default locations;
